import { render, staticRenderFns } from "./ProfileCustomerReview.vue?vue&type=template&id=4e874446"
import script from "./ProfileCustomerReview.vue?vue&type=script&lang=js"
export * from "./ProfileCustomerReview.vue?vue&type=script&lang=js"
import style0 from "./ProfileCustomerReview.vue?vue&type=style&index=0&id=4e874446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports